"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignationOfferTypeEnum = void 0;
var AssignationOfferTypeEnum;
(function (AssignationOfferTypeEnum) {
    AssignationOfferTypeEnum[AssignationOfferTypeEnum["FixedPrice"] = 0] = "FixedPrice";
    AssignationOfferTypeEnum[AssignationOfferTypeEnum["Bidding"] = 1] = "Bidding";
})(AssignationOfferTypeEnum || (exports.AssignationOfferTypeEnum = AssignationOfferTypeEnum = {}));
//# sourceMappingURL=assignation-offer-type.enum.js.map